module.exports = __webpack_public_path__ + "img/kiosk_true.27756fe9.png";